"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UIDialogHeader = _interopRequireDefault(require("../dialog/UIDialogHeader"));

var _Functions = require("../core/Functions");

var _PanelNavigatorContext = require("../context/PanelNavigatorContext");

var _PanelComponentRegistrationContext = require("../context/PanelComponentRegistrationContext");

var _decorators = require("../utils/propTypes/decorators");

var UIPanelHeader = _react.default.createClass({
  displayName: "UIPanelHeader",
  propTypes: (0, _extends2.default)({}, _UIDialogHeader.default.propTypes, {
    children: _react.PropTypes.node,
    panelNavigatorContext: (0, _decorators.hidden)(_PanelNavigatorContext.panelNavigatorContextPropType)
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UIDialogHeader.default.defaultProps);
  },
  getInitialState: function getInitialState() {
    return {
      currentPanel: null
    };
  },
  componentDidMount: function componentDidMount() {
    var _this$props$panelNavi = this.props.panelNavigatorContext,
        panelNavigatorContext = _this$props$panelNavi === void 0 ? {} : _this$props$panelNavi;
    var currentPanel = (0, _Functions.callIfPossible)(panelNavigatorContext.getCurrentPanel);

    if (currentPanel) {
      this.setState({
        currentPanel: currentPanel
      });
    }
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        _this$props$panelNavi2 = _this$props.panelNavigatorContext,
        panelNavigatorContext = _this$props$panelNavi2 === void 0 ? {} : _this$props$panelNavi2,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "panelNavigatorContext"]);
    var currentPanel = this.state.currentPanel;
    var navigation = (0, _Functions.callIfPossible)(panelNavigatorContext.renderNavigation, currentPanel);
    var classes = (0, _classNames.default)(className, 'private-panel__header', {
      'private-panel__header--with-navigation': navigation
    });
    return _react.default.createElement(_UIDialogHeader.default, (0, _extends2.default)({}, rest, {
      className: classes
    }), _react.default.createElement(_PanelComponentRegistrationContext.RegistersPanelHeader, null), navigation, children);
  }
});

var _default = (0, _PanelNavigatorContext.ConsumesPanelNavigatorContext)(UIPanelHeader);

exports.default = _default;
module.exports = exports.default;